export default "__VITE_ASSET__DI_dvRRS__"